/*@flow*/
/** @jsx jsx */
import { jsx, css } from '@emotion/core';
import Blank from 'lib/Blank';

export default (props: { filters: ?Object, onClick: Function }) => {
  if (Blank.is(props.filters)) return null;
  return (
    <button
      css={css(
        'margin: 0 0 0 10px; cursor: pointer; background: none; border: none; color: var(--blue); line-height: 1rem;'
      )}
      onClick={props.onClick}
    >
      Clear filters
    </button>
  );
};
